import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTranslation } from '../../i18n/LocaleContext';

/**
 * 用戶協議／隱私條款內容頁
 */
export default function LegalContentPage({ type }) {
  const navigate = useNavigate();
  const { locale, t } = useTranslation();
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isAgreement = type === 'agreement';
  const titleKey = isAgreement ? 'agreement.title' : 'privacyPolicy.title';
  const loadFailedKey = isAgreement ? 'agreement.loadFailed' : 'privacyPolicy.loadFailed';
  const emptyKey = isAgreement ? 'agreement.empty' : 'privacyPolicy.empty';

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const lang = resolveNewsApiLang(locale);
        const data = isAgreement
          ? await memberApi.agreement({ lang })
          : await memberApi.privacyPolicy({ lang });
        if (!cancelled) {
          setBody(data?.body || '');
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || t(loadFailedKey));
          setBody('');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [isAgreement, locale, loadFailedKey, t]);

  return (
    <div className="legal-content-page">
      <header className="legal-content-page__header">
        <button
          type="button"
          className="legal-content-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
        <h1 className="legal-content-page__title">{t(titleKey)}</h1>
      </header>

      <div className="legal-content-page__body">
        {loading ? <p className="legal-content-page__status">{t('common.loading')}</p> : null}
        {error ? (
          <p className="legal-content-page__status legal-content-page__status--error">{error}</p>
        ) : null}
        {!loading && !error && body ? (
          <div
            className="legal-content-page__html"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        ) : null}
        {!loading && !error && !body ? (
          <p className="legal-content-page__status">{t(emptyKey)}</p>
        ) : null}
      </div>
    </div>
  );
}
